import { useUserData } from "src/context/userContext";
import { authAccess_Page } from "./authAccess_page";
import { authAccess_asiakas } from "./authAccess_asiakas";
import { Button, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { authAccess_person } from "./authAccess_person";
import ProgressCirc from "src/components/layout/Progress/ProgressCirc";
import PropTypes from "prop-types";

export default function AuthAccess({
  page = undefined,
  asiakas = undefined,
  person = undefined,
  children = null,
  showError = false,
  onlyWide = false,
  lazy = false,
}) {
  const { user, userAsiakas, auth, isLoaded: userIsLoaded } = useUserData();
  const navigate = useNavigate();
  if (userAsiakas?.asiakasId > 0 && userAsiakas.isLoaded === undefined) return <ProgressCirc />;

  let allowAccess = { read: false, edit: false };

  if (page !== undefined) {
    // page
    allowAccess = authAccess_Page(page, auth);
  } else if (asiakas !== undefined) {
    // asiakas
    allowAccess = authAccess_asiakas(asiakas, user, userAsiakas);
  } else if (person !== undefined) {
    allowAccess = authAccess_person(person, user, userAsiakas);
  } else {
    console.error("AuthAccess: nothing defined");
    return <div>Access denied: nothing defined</div>;
  }

  if (allowAccess === true || allowAccess?.read === true) {
    if (lazy) {
      return <div className={onlyWide ? "onlyWide" : ""}>{children}</div>;
    } else {
      return children;
    }
  }
  if (!showError || !auth.isLoaded || !userIsLoaded) return null;

  return (
    <Paper
      style={{
        padding: 20,
        margin: 10,
        display: "flex",
        flexDirection: "column",
        gap: 10,
        alignItems: "center",
        border: "1px solid red",
        borderRadius: 4,
      }}>
      <Typography variant="h6" color="primary">
        Ei pääsyä sivulle
      </Typography>
      <Button
        size="large"
        variant="contained"
        onClick={() => navigate("/")}
        autoFocus
        aria-label="Lataa sivu uudestaan">
        PALAA ETUSIVULLE
      </Button>
    </Paper>
  );
}

AuthAccess.propTypes = {
  page: PropTypes.string,
  asiakas: PropTypes.object,
  keikkaId: PropTypes.number,
  person: PropTypes.object,
  children: PropTypes.node,
  showError: PropTypes.bool,
  onlyWide: PropTypes.bool,
  lazy: PropTypes.bool,
};
